export default __webpack_public_path__ + "static/media/Banner contact.f0b9a727.jpg";